<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th v-for="(label, key) in columns" scope="col" :key="key">
          <slot :name="'col-' + (key as string)" :index="key" :label="label">
            {{ label }}
          </slot>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(row, i) in rows" :key="i">
        <td v-for="(_, key) in columns" :key="key">
          <slot :name="key" :index="i" :data="row" :value="row[key as keyof T]">
            {{ row[key as keyof T] }}
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts" generic="T extends object">
type Props = {
  columns: Partial<Record<keyof T, string | null>>;
  rows: T[];
};

defineProps<Props>();
</script>
